import React from "react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import ReportCard from "../ui/ReportCard";
import pending from "../../images/activity.png";

export default function PendingReports({ report }) {
  return <ReportCard title="Pending Reports" text={report} src={pending} />;
}
